import type { Theme } from '@mui/material/styles';
import { getHeaderOverlayZIndex } from '../config/tabKeepAlive';

/** z-index de overlays portados acima da barra de tabs keep-alive (modal+1). */
export const getPortaledOverlayZIndex = (theme: Theme): number => getHeaderOverlayZIndex(theme);

/** Popper portado — acima do dialog, abaixo/interagível com tabs quando aplicável. */
export const portaledAutocompletePopperProps = {
  popper: {
    disablePortal: false,
    sx: { zIndex: getPortaledOverlayZIndex },
  },
} as const;

/** Menu portado do header — acima da barra de tabs keep-alive. */
export const portaledMenuSlotProps = {
  root: {
    sx: { zIndex: getPortaledOverlayZIndex },
  },
} as const;

/** sx para Menu/Popover portado do header. */
export const portaledMenuSx = {
  zIndex: getPortaledOverlayZIndex,
} as const;
